import {charcoal} from '../../sass/v2/_exports.sass';

export const StarIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 8.6875 19.097656 L 6.699219 27.699219 C 6.640625 27.960938 6.65625 28.234375 6.753906 28.484375 C 6.851562 28.734375 7.019531 28.949219 7.238281 29.101562 C 7.460938 29.253906 7.71875 29.335938 7.988281 29.335938 C 8.253906 29.335938 8.515625 29.257812 8.738281 29.109375 L 16 24.269531 L 23.257812 29.109375 C 23.488281 29.257812 23.753906 29.335938 24.027344 29.332031 C 24.300781 29.324219 24.5625 29.234375 24.785156 29.074219 C 25.003906 28.914062 25.171875 28.691406 25.257812 28.433594 C 25.347656 28.175781 25.355469 27.894531 25.28125 27.632812 L 22.84375 19.101562 L 28.890625 13.65625 C 29.085938 13.484375 29.222656 13.257812 29.289062 13.003906 C 29.355469 12.75 29.34375 12.484375 29.261719 12.238281 C 29.179688 11.992188 29.023438 11.773438 28.820312 11.613281 C 28.613281 11.453125 28.363281 11.359375 28.105469 11.339844 L 20.503906 10.734375 L 17.214844 3.453125 C 17.109375 3.21875 16.9375 3.019531 16.722656 2.878906 C 16.507812 2.738281 16.257812 2.664062 16 2.664062 C 15.742188 2.664062 15.492188 2.738281 15.277344 2.878906 C 15.058594 3.019531 14.890625 3.21875 14.785156 3.453125 L 11.496094 10.734375 L 3.894531 11.335938 C 3.636719 11.355469 3.394531 11.449219 3.191406 11.605469 C 2.988281 11.761719 2.832031 11.972656 2.746094 12.210938 C 2.660156 12.453125 2.640625 12.714844 2.699219 12.964844 C 2.757812 13.214844 2.886719 13.441406 3.070312 13.621094 Z M 8.6875 19.097656"
        fill={color}
      />
    </svg>
  );
};
